(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nahyana-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nahyanaInfoTabs) {
    window.__nahyanaInfoTabs = true;

    const closeAll = (root) => {
      root.querySelectorAll('.nahyana-info-tabs__btn').forEach((b) => b.setAttribute('aria-selected', 'false'));
      root.querySelectorAll('.nahyana-info-tabs__panel').forEach((p) => p.setAttribute('hidden', ''));
    };

    const open = (button) => {
      const root = button.closest('.nahyana-info-tabs');
      if (!root) return;

      closeAll(root);
      button.setAttribute('aria-selected', 'true');
      const panel = root.querySelector('#' + button.getAttribute('aria-controls'));
      if (panel) panel.removeAttribute('hidden');
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.nahyana-info-tabs__btn');
      if (!button) return;

      if (button.getAttribute('aria-selected') === 'true') {
        closeAll(button.closest('.nahyana-info-tabs'));
      } else {
        open(button);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      const button = event.target.closest && event.target.closest('.nahyana-info-tabs__btn');
      if (!button) return;

      const buttons = Array.from(button.closest('.nahyana-info-tabs__list').querySelectorAll('.nahyana-info-tabs__btn'));
      const step = event.key === 'ArrowRight' ? 1 : buttons.length - 1;
      const next = buttons[(buttons.indexOf(button) + step) % buttons.length];
      next.focus();
      open(next);
      event.preventDefault();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
